import { observer } from 'mobx-react-lite';
import styles from './style.module.css';
import m from 'skin/store/mb'
import Icon from '../icon';

/**
 * @param {'base'|'base-reverse'|'link'|'link2'|'link-below'} props.type тип кнопки
 * @param {boolean} [props.mini] миниатюрная кнопка
 * @param {Function} props.onClick обработчик нажатия
 */
const Button = observer(function({ disabled, className, mini, type, icon, onClick, children, ...props }) {
	const mb = m.isMobile;
	const classes = [styles.body, styles[type], styles[mb ? 'mb' : 'pc']]
	if (className) classes.push(className);
	if (mini) classes.push(styles.mini);
	return <button disabled={!onClick || disabled} type='button' className={classes.join(' ')} onClick={onClick} {...props}>
		{children}
		{icon ? <Icon name={icon} /> : null}
	</button>
})

export default Button;